/**
 * @file
 *
 * Initializes Lity and applies the legacy image caption behavior.
 */

import lity from 'lity';

// Preserve the global API exposed by the legacy standalone script.
window.lity = lity;

jQuery(document).ready(function($) {
	$(document).on('lity:ready', function(event, instance) {
		var lityWrapper = $(event.target).parent();
		var lityImg = $(event.target);
		var lityCaption = $(lityImg).attr('alt');
		var currWindowHeight = $(window).height();
		var lityImgWidth = $(event.target).width();
		var lityWrapperMaxHeight = Math.floor(currWindowHeight * 0.8);

		$(lityImg).css({'max-height': lityWrapperMaxHeight + 'px'});

		if (lityCaption && lityCaption != 'Image with no description') {
			$(lityWrapper).append('<div class="lity-caption"><p>' + lityCaption + '</p></div>');
		}
	});
});
